import { type DominoViewDto } from '@spin/shared';
import { tNow } from '../i18n';
import { useSession } from '../store/session';
import { useUi } from '../store/ui';
import { game } from './game';

/**
 * Domino rooms push each player their own view. The open game screen picks it up; a game that starts while the
 * player is elsewhere (the room filled up) takes them to the table, since their turns are timed.
 */
game.on('domino.update', (view: DominoViewDto) => {
  window.dispatchEvent(new CustomEvent<DominoViewDto>('spin:domino', { detail: view }));
  const session = useSession.getState();
  const top = session.stack.at(-1);
  const here = top?.name === 'dominoRoom' && top.id === view.id;
  if (here) return;
  if (view.status === 'PLAYING' && view.round === 1 && view.chain.length === 0) {
    useUi.getState().toast(`🎲 ${tNow('domino.started')}`, 'success');
    session.go({ name: 'dominoRoom', id: view.id });
  } else if (view.status === 'CANCELLED') {
    useUi.getState().toast(tNow('domino.cancelled'), 'info');
  }
});
